export const en = {
	'welcome.title': 'Welcome to Mainean',

	// Login page
	'login.app.name': 'MaintenanceHub',
	'login.app.subtitle': 'Maintenance Operations Control Center',
	'login.welcome.title': 'Welcome Back',
	'login.welcome.subtitle': 'Sign in to access your dashboard',
	'login.button.azure': 'Sign in with Microsoft Azure',
	'login.button.loading': 'Signing in...',

	// System status
	'login.status.title': 'System Status',
	'login.status.online': 'Online',
	'login.status.sap.label': 'SAP Integration',
	'login.status.sap.value': 'Connected',
	'login.status.aveva.label': 'AVEVA Permits',
	'login.status.aveva.value': 'Active',
	'login.status.twin.label': 'Digital Twin',
	'login.status.twin.value': 'Ready',

	// Footer
	'login.footer.copyright': '© 2024 MaintenanceHub. Secure offshore maintenance operations.',
	'login.footer.privacy': 'Privacy Policy',
	'login.footer.terms': 'Terms of Service',
	'login.footer.support': 'Support',

	// User Profile page
	'profile.page.title': 'User Profile',
	'profile.page.back': 'Go back',
	'profile.memberSince': 'Member Since',
	'profile.totalExperience': 'Total Experience',
	'profile.yearsExperience': 'Years',
	'profile.editProfile': 'Edit Profile',
	'profile.tasksCompleted': 'Tasks Completed',
	'profile.onTimeCompletion': 'On-Time Completion',
	'profile.performanceScore': 'Performance Score',
	'profile.companyWideRanking': 'Company-wide ranking',
	'profile.qualityScore': 'Quality Score',
	'profile.performanceTrends': 'Performance Trends',
	'profile.period.3m': 'Last 3 Months',
	'profile.period.6m': 'Last 6 Months',
	'profile.period.1y': 'Last Year',
	'profile.taskDistribution': 'Task Distribution',
	'profile.achievementsBadges': 'Achievements & Badges',
	'profile.earned': 'earned',
	'profile.viewAllBadges': 'View all {count} badges',
	'profile.showLess': 'Show less',
	'profile.recentActivity': 'Recent Activity',
	'profile.recentActivity.previous': 'Previous',
	'profile.recentActivity.next': 'Next',
	'profile.recentActivity.position': '{page} of {totalPages}',
	'profile.recentActivity.empty': 'No recent activity',
	'profile.skillsExpertise': 'Skills & Expertise',
	'profile.certifications': 'Certifications',
	'profile.validUntil': 'Valid until',
	'profile.expiresIn': 'Expires in {days} days',
	'profile.cert.status.valid': 'Valid',
	'profile.cert.status.expiring': 'Expiring',
	'profile.cert.status.expired': 'Expired',
	'profile.fullName': 'Full Name',
	'profile.email': 'Email',
	'profile.phone': 'Phone',
	'profile.location': 'Location',
	'profile.readOnly': 'read-only',
	'profile.cancel': 'Cancel',
	'profile.saving': 'Saving...',
	'profile.saveChanges': 'Save Changes',

	// Sidebar navigation
	'sidebar.nav.home': 'Home',
	'sidebar.nav.plantMaintenance': 'Plant Maintenance',
	'sidebar.nav.plantNotifications': 'Plant Notifications',
	'sidebar.nav.campaign': 'Campaign',
	'sidebar.nav.logistics': 'Logistics',
	'sidebar.nav.reports': 'Reports',
	'sidebar.app.tagline': 'Enterprise',
	'sidebar.openMenu': 'Open menu',
	'sidebar.closeMenu': 'Close menu',

	// Work Orders Table
	'workOrdersTable.header.title': 'All Work Orders',
	'workOrdersTable.header.subtitle': 'Filtered by role: Planner, Electro',
	'workOrdersTable.search.placeholder': 'Search WO, Tag, or Description...',
	'workOrdersTable.column.woNumber': 'WO Number',
	'workOrdersTable.column.description': 'Description',
	'workOrdersTable.column.priority': 'Priority',
	'workOrdersTable.column.criticality': 'Criticality',
	'workOrdersTable.column.installation': 'Installation',
	'workOrdersTable.column.status': 'Status',
	'workOrdersTable.column.assignedTo': 'Assigned To',
	'workOrdersTable.assignee.unassigned': 'Unassigned',
	'workOrdersTable.column.requiredEndDate': 'LACD',
	'workOrdersTable.empty': 'No work orders found',
	'workOrdersTable.error.loadFailed': 'Failed to load work orders',

	// Work Orders Filter Modal
	'workOrdersTable.filter.title': 'Filter Work Orders',
	'workOrdersTable.filter.priority.label': 'Priority',
	'workOrdersTable.filter.priority.placeholder': 'All priorities',
	'workOrdersTable.filter.status.label': 'Status',
	'workOrdersTable.filter.status.placeholder': 'All statuses',
	'workOrdersTable.filter.criticality.label': 'Criticality',
	'workOrdersTable.filter.criticality.placeholder': 'All levels',
	'workOrdersTable.filter.installation.label': 'Installation',
	'workOrdersTable.filter.installation.placeholder': 'All installations',
	'workOrdersTable.filter.assignedTo.label': 'Assigned To',
	'workOrdersTable.filter.assignedTo.placeholder': 'Filter by person...',
	'workOrdersTable.filter.sortBy.label': 'Sort By',
	'workOrdersTable.filter.sortBy.placeholder': 'Default order',
	'workOrdersTable.filter.sortBy.requiredEndDate': 'LACD',
	'workOrdersTable.filter.sortBy.priority': 'Priority',
	'workOrdersTable.filter.sortBy.status': 'Status',
	'workOrdersTable.filter.sortBy.criticality': 'Criticality',
	'workOrdersTable.filter.sortDirection.label': 'Sort Direction',
	'workOrdersTable.filter.sortDirection.placeholder': 'Default',
	'workOrdersTable.filter.sortDirection.asc': 'Ascending',
	'workOrdersTable.filter.sortDirection.desc': 'Descending',
	'workOrdersTable.filter.reset': 'Reset all',
	'workOrdersTable.filter.apply': 'Apply filters',
	'workOrdersTable.filter.discipline.label': 'Discipline',
	'workOrdersTable.filter.discipline.placeholder': 'All disciplines',

	// Work Orders Discipline column
	'workOrders.table.discipline': 'Discipline',

	// Work Orders Bulk Actions
	'workOrders.bulk.selected': '{count} work orders selected',
	'workOrders.bulk.apply': 'Apply',
	'workOrders.bulk.clear': 'Clear selection',
	'workOrders.bulk.priority': 'Set Priority',
	'workOrders.bulk.status': 'Set Status',
	'workOrders.bulk.assignTo': 'Assign To',
	'workOrders.bulk.successToast': '{count} work orders updated',
	'workOrders.bulk.status.noCommon': 'No status is available for every selected work order',

	// Pagination
	'pagination.previous': 'Previous',
	'pagination.next': 'Next',
	'pagination.showing': 'Showing {count} of {total} Work Orders',

	// Work Order Detail
	'workOrder.header.fallback': 'Work Order',
	'workOrder.notFound': 'Work order not found',
	'workOrder.backToDashboard': 'Back to Dashboard',
	'workOrder.error.loadFailed': 'Failed to load work order details',

	// Work Order Status / Criticality
	'workOrder.status.open': 'Open',
	'workOrder.status.closed': 'Closed',
	'workOrder.status.overdue': 'Overdue',
	'workOrder.status.dueSoon': 'Due Soon',
	'workOrder.status.planned': 'Planned',
	'workOrder.status.scheduled': 'Scheduled',
	'workOrder.status.prepared': 'Prepared',
	'workOrder.status.executed': 'Executed',
	'workOrder.criticality.low': 'Low',
	'workOrder.criticality.medium': 'Medium',
	'workOrder.criticality.critical': 'Critical',

	// Priority Badge
	'priorityBadge.label': 'PRIORITY {priority}',

	// Task Description
	'taskDescription.title': 'Task Description',

	// Subtasks
	'subtasks.title': 'Subtasks',
	'subtasks.progress': '{completed} of {total} completed',
	'subtasks.planned': 'Planned: {date}',
	'subtasks.completed': 'Completed {date}',

	// Assigned Personnel
	'assignedPersonnel.title': 'Assigned Personnel',
	'assignedPersonnel.add': 'Add',
	'assignedPersonnel.unknown': 'Unknown',

	// Spare Parts
	'spareParts.title': 'Spare Parts',
	'spareParts.status.available': 'Available',
	'spareParts.status.inTransit': 'In Transit',
	'spareParts.status.missing': 'Missing',
	'spareParts.status.reserved': 'Reserved',
	'spareParts.status.unknown': 'Unknown',
	'spareParts.partInfo': 'P/N: {partNumber} • Qty: {quantity}',
	'spareParts.unknownPart': 'Unknown Part',

	// Related Work Orders
	'relatedWorkOrders.title': 'Related Work Orders for Same System',
	'relatedWorkOrders.available': '{count} Available',
	'relatedWorkOrders.description': 'Combine maintenance tasks to optimize time and resources',
	'relatedWorkOrders.collapse': 'Collapse',
	'relatedWorkOrders.expandAll': 'Expand All',
	'relatedWorkOrders.efficiency.title': 'Efficiency Recommendation',
	'relatedWorkOrders.efficiency.description':
		'Combining these work orders could save approximately {hours} hours of downtime and reduce logistics costs by {amount}',
	'relatedWorkOrders.card.due': 'Due: {date}',
	'relatedWorkOrders.card.est': 'Est: {hours} hours',
	'relatedWorkOrders.card.technicians': '{count, plural, one {# technician} other {# technicians}}',
	'relatedWorkOrders.card.addToBatch': 'Add to Batch',
	'relatedWorkOrders.card.viewDetails': 'View Details',

	// Logs & Comments
	'logsAndComments.title': 'Logs & Comments',
	'logsAndComments.addComment': 'Add Comment',
	'logsAndComments.time.unknown': 'Unknown time',
	'logsAndComments.time.justNow': 'Just now',
	'logsAndComments.time.hoursAgo': '{hours, plural, one {# hour ago} other {# hours ago}}',
	'logsAndComments.time.daysAgo': '{days, plural, one {# day ago} other {# days ago}}',
	'logsAndComments.comment': 'Comment',
	'logsAndComments.dialog.title': 'Add Comment',
	'logsAndComments.dialog.actionLabel': 'Action Type',
	'logsAndComments.dialog.actionPlaceholder': 'Select action type',
	'logsAndComments.dialog.action.comment': 'Comment',
	'logsAndComments.dialog.action.reject': 'Reject',
	'logsAndComments.dialog.action.requestMoreInfo': 'Request More Info',
	'logsAndComments.dialog.descriptionLabel': 'Description',
	'logsAndComments.dialog.descriptionPlaceholder': 'Enter your comment...',
	'logsAndComments.dialog.cancel': 'Cancel',
	'logsAndComments.dialog.submit': 'Submit',
	'logsAndComments.dialog.submitting': 'Submitting...',
	'logsAndComments.noComments': 'No comments yet',

	// Layout Documents
	'layoutDocuments.title': 'Layout Documents',
	'layoutDocuments.revision': 'Rev {revision}',
	'layoutDocuments.open': 'Open',

	// ICC Plan Viewer
	'iccPlanViewer.title': 'ICC Plan Viewer',
	'iccPlanViewer.fullView': 'Full View',
	'iccPlanViewer.certificateLabel': 'Isolation Certificate Plan',

	// Other Attachments
	'otherAttachments.title': 'Other Attachments',
	'otherAttachments.uploadNew': 'Upload New',

	// Home Page
	'homePage.title': 'Dashboard Overview',
	'homePage.subtitle': 'Maintenance operations control center',

	// Critical Tasks
	'criticalTasks.title': 'Critical Tasks',
	'criticalTasks.subtitle': 'Next 7 Days • High Priority Focus',
	'criticalTasks.error.loadFailed': 'Failed to load critical tasks',
	'criticalTasks.empty': 'No critical tasks at this time',
	'criticalTasks.total': 'Total',

	// User Workload
	'userWorkload.title': 'My Workload',
	'userWorkload.error.loadFailed': 'Failed to load workload',
	'userWorkload.status.planned': 'Planned',
	'userWorkload.status.workingOn': 'Working on',
	'userWorkload.status.toBePlanned': 'To be planned',
	'userWorkload.status.completed': 'Completed',
	'userWorkload.status.inProgress': 'In Progress',

	// Reports Page
	'reportsPage.title': 'Maintenance Analytics',
	'reportsPage.subtitle': 'Reports for {start} – {end}',

	// Date Range Picker
	'dateRangePicker.last7Days': 'Last 7 Days',
	'dateRangePicker.last30Days': 'Last 30 Days',
	'dateRangePicker.last90Days': 'Last 90 Days',
	'dateRangePicker.last12Months': 'Last 12 Months',

	// Analytics Summary
	'analyticsSummary.totalWorkOrders': 'Total Work Orders',
	'analyticsSummary.completionRate': 'Completion Rate',
	'analyticsSummary.avgResponseTime': 'Avg Response Time',
	'analyticsSummary.overdue': 'Overdue',

	// Completion Status Chart
	'completionStatus.title': 'Completion Status',
	'completionStatus.subtitle': 'Work order status breakdown',

	// Equipment Downtime Chart
	'equipmentDowntime.title': 'Equipment Downtime Analysis',
	'equipmentDowntime.week': 'Week {n}',
	'equipmentDowntime.planned': 'Planned',
	'equipmentDowntime.unplanned': 'Unplanned',

	// Monthly Performance Chart
	'monthlyPerformance.title': 'Monthly Performance Metrics',
	'monthlyPerformance.onTrack': 'On Track',
	'monthlyPerformance.completionRate': 'Completion Rate',

	// Performance by Installation Chart
	'performanceByInstallation.title': 'Performance by Installation',
	'performanceByInstallation.all': 'All',
	'performanceByInstallation.completed': 'Completed',
	'performanceByInstallation.inProgress': 'In Progress',
	'performanceByInstallation.overdue': 'Overdue',

	// Priority Breakdown
	'priorityBreakdown.title': 'Priority Breakdown',
	'priorityBreakdown.subtitle': 'Work orders by priority level',
	'priorityBreakdown.empty': 'No data available',

	// Work Order Trends Chart
	'workOrderTrends.title': 'Work Order Trends',

	// Discipline Chart
	'disciplineChart.title': 'Work Orders by Discipline',
	'disciplineChart.subtitle': 'Breakdown by maintenance discipline',
	'disciplineChart.completed': 'Completed',
	'disciplineChart.pending': 'Pending',

	// Error / Loading states
	'errorState.message': 'Something went wrong',
	'errorState.retry': 'Retry',

	// Settings page
	'settings.page.title': 'Settings & Administration',
	'settings.page.subtitle': 'System configuration and user management',
	'sidebar.nav.settings': 'Settings',

	// User Roles & Permissions widget
	'settings.userRoles.title': 'User Roles & Permissions',
	'settings.userRoles.editUser': 'Edit user',
	'settings.userRoles.viewAll': 'View All Users ({count})',
	'settings.userRoles.role.administrator': 'Administrator',
	'settings.userRoles.role.notAdmin': 'Standard user',
	'settings.userRoles.search.placeholder': 'Search by name or email',
	'settings.userRoles.column.admin': 'Admin',
	'settings.userRoles.column.name': 'Name',
	'settings.userRoles.column.email': 'Email',
	'settings.userRoles.empty': 'No users found',
	'settings.userRoles.pagination.previous': 'Previous',
	'settings.userRoles.pagination.next': 'Next',
	'settings.userRoles.pagination.position': '{page} of {totalPages}',

	// Edit User modal
	'settings.editUser.title': 'Edit User',
	'settings.editUser.name': 'Name',
	'settings.editUser.email': 'Email',
	'settings.editUser.admin': 'Administrator',
	'settings.editUser.installations': 'Installations',
	'settings.editUser.installation': 'Installation',
	'settings.editUser.disciplines': 'Disciplines',
	'settings.editUser.disciplines.placeholder.none': 'None',
	'settings.editUser.disciplines.placeholder.all': 'All disciplines',
	'settings.editUser.disciplines.selectAll': 'Select all',
	'settings.editUser.disciplines.clear': 'Clear',
	'settings.editUser.disciplines.done': 'Done',
	'settings.editUser.disciplines.close': 'Close',
	'settings.editUser.disciplines.empty': 'No disciplines available',
	'settings.editUser.disciplines.searchPlaceholder': 'Search disciplines',
	'settings.editUser.disciplines.triggerAria': 'Edit disciplines for {installation}',
	'settings.editUser.save': 'Save',
	'settings.editUser.cancel': 'Cancel',
	'settings.editUser.saving': 'Saving…',
	'settings.editUser.loadError': 'Could not load user details. Please try again.',

	// Data Import
	'settings.importData.title': 'Data Import',
	'settings.importData.subtitle': 'Upload an Excel file to import data into an installation',
	'settings.importData.installationLabel': 'Installation',
	'settings.importData.installationPlaceholder': 'Select an installation',
	'settings.importData.dropzone.idle': 'Drag and drop a file here, or click to browse',
	'settings.importData.dropzone.hint': 'XLSX or XLS, max 1 file',
	'settings.importData.remove': 'Remove file',
	'settings.importData.submit': 'Import',
	'settings.importData.submitting': 'Importing…',
	'settings.importData.success': 'Data imported successfully.',
	'settings.importData.error': 'Failed to import data. Please try again.',
	'settings.importData.errors.invalidType': 'Only .xlsx or .xls files are allowed.',
	'settings.importData.errors.tooManyFiles': 'You can only upload one file at a time.',

	// Common
	'common.loading': 'Loading…',
};
